// States, labels, scheduling limits and platform detection are shared with
// Desktop (@copilot/ui's autoAttend.ts). Only the error codes are Web's
// own: they are what the bot-meetings API answers with.
export {
  ACTIVE_STATES,
  BOT_POLL_INTERVAL_MS,
  BOT_STATES,
  BOT_STATE_META,
  CANCELLABLE_STATES,
  DEFAULT_SUMMARY_LANGUAGE,
  MAX_FUTURE_DAYS,
  MAX_PAST_MINUTES,
  MAX_TITLE_LENGTH,
  OPENABLE_RESULT_STATES,
  PLATFORM_LABELS,
  RESCHEDULABLE_STATES,
  TONE_BADGE_VARIANT,
  botStateMeta,
  detectPlatform,
  platformLabel,
} from '@copilot/ui';

export const BOT_ERROR_CODES = {
  INVALID: 'INVALID_BOT_MEETING',
  REFUSED: 'MEETING_BOT_REFUSED',
  LIMIT_REACHED: 'MEETING_BOT_LIMIT_REACHED',
  STATE_CONFLICT: 'BOT_MEETING_STATE_CONFLICT',
  NOT_FOUND: 'BOT_MEETING_NOT_FOUND',
  UNAVAILABLE: 'MEETING_BOTS_UNAVAILABLE',
  SERVICE_BUSY: 'MEETING_BOT_SERVICE_BUSY',
};
